<template>
  <v-img
    class="flag-icon"
    :class="[size, marginRight]"
    :src="asset(`img/flag/${icon}.svg`)"
  ></v-img>
</template>
<script>
export default {
  props: ["icon", "size", "marginRight"], //size: large
};
</script>
<style lang="scss">
.flag-icon {
  width: 100%;
  max-width: 28px !important;
  .v-image__image {
    background-size: contain;
  }
  &.large {
    max-width: 48px !important;
    width: 48px !important;
  }
  &.big {
    max-width: 68px !important;
    width: 68px !important;;
  }
  &.margin-right-10 {
    margin-right: 10px;
  }
}
</style>